import { useCallback } from 'react';
import { useGetDisplayWebContentSelector } from './useGetDisplayWebContentSelector';

export const useGetControlGroupSelector = () => {
  const getDisplayWebContent = useGetDisplayWebContentSelector();

  const controlGroupEnabled = useCallback((id: string) => getDisplayWebContent(id)?.controlGroupEnabled, [
    getDisplayWebContent,
  ]);

  // get the exsisting weight of the control group
  // 10 if one has not been set
  const controlGroupWeight = useCallback((id: string) => getDisplayWebContent(id)?.controlGroupWeight ?? 10, [
    getDisplayWebContent,
  ]);

  return { controlGroupEnabled, controlGroupWeight };
};
